import {
  GET_USERS_LIST,
  GET_USERS_LIST_SUCCESS,
  GET_USERS_LIST_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  usersList: [],
};

const getUsersListReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_LIST:
      return { ...state, loading: true };
    case GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        usersList: action?.payload,
        loading: false,
      };
    case GET_USERS_LIST_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getUsersListReducer;
